import { POTypeEnum, StatusEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";




@Entity("purchase_order")

export class AssetsPo {

    @PrimaryGeneratedColumn("increment", { name: 'purchase_order_id' })
    purchaseOrderId: number;

    @Column({
        nullable: false,
        name: "purchase_order_date"
    })
    purchaseOrderDate: Date;
    @Column("int", {
        nullable: false,
        name: "vendor_name"
    })
    vendorName: number;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "po_number"
    })
    poNumber: string;


    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: true,
        name: "exchange_rate",
        default: 0
    })
    exchangeRate: number;


    @Column("int", {
        name: "sale_order_id"
    })
    saleOrderId: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: true,
        name: "total_transportation",
        default: 0
    })
    totalTransportation: number;


    @Column("int", {
        nullable: true,
        name: "payment_terms"
    })
    paymentTerms: number;

    @Column({
        nullable: false,
        name: "expected_delivery_date"
    })
    expectedDeliveryDate: Date;

    @Column("varchar", {
        nullable: true,
        length: 30,
        name: "note"
    })
    note: string;

    @Column("varchar", {
        nullable: true,
        length: 30,
        name: "other_terms"
    })
    otherTerms: string;

    @Column("varchar", {
        nullable: true,
        length: 30,
        name: "remarks"
    })
    remarks: string;


    @Column("varchar", {
        nullable: false,
        length: 250,
        name: "delivery_address"
    })
    deliveryAddress: string;

    @Column("varchar", {
        nullable: false,
        length: 250,
        name: "billing_address"
    })
    billingAddress: string;

    @Column("int", {
        nullable: true,
        name: "unit_id"
    })
    unitId: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "total_amount",
        default: 0
    })
    totalAmount: number;

    @CreateDateColumn({ name: "created_at" })
    createdAt: Date;


    @Column("varchar", {
        nullable: false,
        length: 40,
        name: "created_user"
    })
    createdUser: string | null;


    @UpdateDateColumn({ name: "updated_at" })
    updatedAt: Date;


    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;


    @Column({
        type: 'enum',
        enum: StatusEnum,
        nullable: false,
        name: 'status',
        default: StatusEnum.OPEN
    })
    status: StatusEnum;

    @Column({
        type: 'enum',
        enum: POTypeEnum,
        nullable: false,
        name: 'po_type',
        default: POTypeEnum.WITHSO
    })
    poType: POTypeEnum;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

}